import { SkirtingType } from "@covertree/agent-portal-graphql";

export const mapSkirtingType = (skirtingType: SkirtingType): string => {
  switch (skirtingType) {
    case SkirtingType.NotListed:
      return "Not Listed";
    case SkirtingType.NotFullyEnclosed:
      return "Not Fully Enclosed";
    case SkirtingType.MasonryBrick:
      return "Masonry/Brick";
    default:
      return skirtingType;
  }
};
